import angular from 'angular';
import loanAmountForAliModal from './loanAmountForAliModal';

export default angular
  .module('components.loanAmountForAliModal', [])
  .component('loanAmountForAliModal', loanAmountForAliModal).name;
